import { connect } from 'react-redux';
import { compose} from 'recompose';

import FinalPage from './FinalPage';

const mapStateToProps = state => ({
    data: state,
});

export default compose(
    connect(mapStateToProps),
)(FinalPage);
